module.exports = __webpack_public_path__ + "static/media/34DSS12.f116ba9b.jpg";